<template>
  <div v-if="! loading">
    <div class="mb-3" v-if="false">
      <input v-model="filter" class="form-control" placeholder="Filter activities">
    </div>
    <div class="row">
      <div class="col-sm-4 col-md-4" v-for="card in CardsList" :key="card.id">
        <CardSingle :data="card"/>
      </div>
    </div>
  </div>
  <div v-else>
    <div class="d-flex justify-content-center align-items-center vh-100">
      <div class="text-warning" style="font-size: 6rem;">
        <i class="fas fa-spinner fa-spin"></i>
      </div>
    </div>
  </div>
</template>

<script>
import CardSingle from './CardSingle.vue'
import Vuex from "vuex"

// import "@fancyapps/ui/dist/fancybox.css";
// import Fancybox from "@fancyapps/ui";

export default {
  emits:['on_number_of_activities_changed'],
  methods:{
    number_of_activities_changed(){
      this.$emit('on_number_of_activities_changed', this.number_of_results);
    }
  },
  name: 'CardList',
  components:{
    CardSingle
  },
  props: {
    
  },
  data(){
    return {
      number_of_results: 0,
    }
  },
  computed:{
    ...Vuex.mapState(['cards', 'loading', 'filter', 'filter_type', 'filter_categorie']),
    ...Vuex.mapGetters(['CardsList', 'NumCards']),
  }
}
</script>